module.exports = __webpack_public_path__ + "static/media/icon-filter-options.b1626741.svg";